import DebateUser from "./User";
import DebateDesc from "./Desc";
import DebateButtons from "./Buttons";
import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { CommnetComponentsType } from "types/main";
import { useState } from "react";
import CommentInput from "../../Input";

function DebateContentIndex({
  data,
  type,
}: {
  data: CommentItem;
  type: CommnetComponentsType;
}) {
  const [mode, setMode] = useState<"read" | "edit">("read");
  return (
    <>
      <DebateUser data={data} type={type} />
      {mode === "read" ? (
        <>
          <DebateDesc data={data} type={type} />
          <DebateButtons data={data} type={type} setMode={setMode} />
        </>
      ) : (
        <div onClick={(e: any) => e.stopPropagation()}>
          <CommentInput
            type={type}
            mode="edit"
            opinionId={data.parent_id || data.comment_id} // 의견이면 parent_id, 댓글이면 comment_id
            editText={data?.description}
            setMode={setMode}
            commentId={data.comment_id}
            isNewComment={(data as any)?.isNewComment || false}
          />
        </div>
      )}
    </>
  );
}

export default DebateContentIndex;
